import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { apiSlice } from "./apiSlice";
import type { IIPRCalculator, IPRCalculationType } from "../../calculators/IPR/interfaces";
import type { IDisplayField, IField, unitId } from "../../interfaces/interfaces";
import { UnitConverter } from "../../components/MeasurementUnits/UnitConverter";

//k_g | k, k_rg (либо просто поле k_g, либо два поля k, k_rg)
//k_v, h, r_e, r_w, s, d | vertical

//k_h, h, r_w, s, d, l, delta_l, delta_w | horizontal
// a, b 

export const initialState: IIPRCalculator = {
	well1: {
		id: "well1",
		calculationType: "horizontal",
		verticalInputs: [
			{
				id: 'ipr-well1-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 30,
				currentValue: 30,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 9.00,
				currentValue: 9.00,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-v',
				type: 'string',
				label: '',
				queryName: 'k_v',
				baseUnitId: null,
				baseValue: 0.1,
				currentValue: 0.1,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-h',
				type: 'string',
				label: '',
				queryName: 'h',
				baseUnitId: 'meter',
				baseValue: 15,
				currentValue: 15,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-re',
				type: 'string',
				label: '',
				queryName: 'r_e',
				baseUnitId: 'meter',
				baseValue: 1000,
				currentValue: 1000,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-r-w',
				type: 'string',
				label: '',
				queryName: 'r_w',
				baseUnitId: 'meter',
				baseValue: 0.100,
				currentValue: 0.100,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-s',
				type: 'string',
				label: '',
				queryName: 's',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-d',
				type: 'string',
				label: '',
				queryName: 'd',
				baseUnitId: null,
				baseValue: 0.000003168,
				currentValue: 0.000003168,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
		],
		horizontalInputs: [
			{
				id: 'ipr-well1-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 30,
				currentValue: 30,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 9.00,
				currentValue: 9.00,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},

			{
				id: 'ipr-well1-input-k-h',
				type: 'string',
				label: '',
				queryName: 'k_h',
				baseUnitId: null,
				baseValue: 0.1,
				currentValue: 0.1,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-h',
				type: 'string',
				label: '',
				queryName: 'h',
				baseUnitId: 'meter',
				baseValue: 15,
				currentValue: 15,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-r-w',
				type: 'string',
				label: '',
				queryName: 'r_w',
				baseUnitId: 'meter',
				baseValue: 0.100,
				currentValue: 0.100,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-s',
				type: 'string',
				label: '',
				queryName: 's',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-d',
				type: 'string',
				label: '',
				queryName: 'd',
				baseUnitId: null,
				baseValue: 0.000003168,
				currentValue: 0.000003168,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-l',
				type: 'string',
				label: '',
				queryName: 'l',
				baseUnitId: 'meter',
				baseValue: 10,
				currentValue: 10,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0,
			},
			{
				id: 'ipr-well1-input-delta-l',
				type: 'string',
				label: '',
				queryName: 'delta_l',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-delta-w',
				type: 'string',
				label: '',
				queryName: 'delta_w',
				baseUnitId: 'meter',
				baseValue: 0,
				currentValue: 0,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
			},
		],
		jonesInputs: [
			{
				id: 'ipr-well1-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well1-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 30,
				currentValue: 30,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 9.00,
				currentValue: 9.00,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-a',
				type: 'string',
				label: '',
				queryName: 'a',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well1-input-b',
				type: 'string',
				label: '',
				queryName: 'b',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
		],
		chartData: {}
	},
	well2: {
		id: "well2",
		calculationType: "horizontal",
		verticalInputs: [
			{
				id: 'ipr-well2-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 3,
				currentValue: 3,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 0.9,
				currentValue: 0.9,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-v',
				type: 'string',
				label: '',
				queryName: 'k_v',
				baseUnitId: null,
				baseValue: 0.1,
				currentValue: 0.1,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-h',
				type: 'string',
				label: '',
				queryName: 'h',
				baseUnitId: 'meter',
				baseValue: 15,
				currentValue: 15,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-re',
				type: 'string',
				label: '',
				queryName: 'r_e',
				baseUnitId: 'meter',
				baseValue: 0.100,
				currentValue: 0.100,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-r-w',
				type: 'string',
				label: '',
				queryName: 'r_w',
				baseUnitId: 'meter',
				baseValue: 0.100,
				currentValue: 0.100,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-s',
				type: 'string',
				label: '',
				queryName: 's',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-d',
				type: 'string',
				label: '',
				queryName: 'd',
				baseUnitId: null,
				baseValue: 0.000003168,
				currentValue: 0.000003168,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
		],
		horizontalInputs: [
			{
				id: 'ipr-well2-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 3,
				currentValue: 3,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 0.9,
				currentValue: 0.9,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},

			{
				id: 'ipr-well2-input-k-h',
				type: 'string',
				label: '',
				queryName: 'k_h',
				baseUnitId: null,
				baseValue: 0.1,
				currentValue: 0.1,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-h',
				type: 'string',
				label: '',
				queryName: 'h',
				baseUnitId: 'meter',
				baseValue: 15,
				currentValue: 15,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-r-w',
				type: 'string',
				label: '',
				queryName: 'r_w',
				baseUnitId: 'meter',
				baseValue: 0.100,
				currentValue: 0.100,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-s',
				type: 'string',
				label: '',
				queryName: 's',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-d',
				type: 'string',
				label: '',
				queryName: 'd',
				baseUnitId: null,
				baseValue: 0.000003168,
				currentValue: 0.000003168,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-l',
				type: 'string',
				label: '',
				queryName: 'l',
				baseUnitId: 'meter',
				baseValue: 1500,
				currentValue: 1500,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-delta-l',
				type: 'string',
				label: '',
				queryName: 'delta_l',
				baseUnitId: 'meter',
				baseValue: 2000,
				currentValue: 2000,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-delta-w',
				type: 'string',
				label: '',
				queryName: 'delta_w',
				baseUnitId: 'meter',
				baseValue: 1000,
				currentValue: 0,
				currentUnitId: 'meter',
				unitCategoryId: 'length',
				userValue: null,
				userUnitId: null,
			},
		],
		jonesInputs: [
			{
				id: 'ipr-well2-input-pressure',
				type: 'string',
				label: '',
				queryName: 'pressure_res',
				baseUnitId: 'bar',
				baseValue: 260,
				currentValue: 260,
				currentUnitId: 'bar',
				unitCategoryId: 'pressure',
				userValue: null,
				userUnitId: null,
				min: 0
			},
			{
				id: 'ipr-well2-input-k',
				type: 'string',
				label: '',
				queryName: 'k',
				baseUnitId: 'millidarcy',
				baseValue: 3,
				currentValue: 3,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-rg',
				type: 'string',
				label: '',
				queryName: 'k_rg',
				baseUnitId: null,
				baseValue: 0.30,
				currentValue: 0.30,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-k-g',
				type: 'string',
				label: '',
				queryName: 'k_g',
				baseUnitId: 'millidarcy',
				baseValue: 0.9,
				currentValue: 0.9,
				currentUnitId: 'millidarcy',
				unitCategoryId: 'absolute_permeability',
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-a',
				type: 'string',
				label: '',
				queryName: 'a',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
			{
				id: 'ipr-well2-input-b',
				type: 'string',
				label: '',
				queryName: 'b',
				baseUnitId: null,
				baseValue: 0,
				currentValue: 0,
				currentUnitId: null,
				unitCategoryId: null,
				userValue: null,
				userUnitId: null,
			},
		],
		chartData: {}
	},
	notes: [
		{ p: null, q: null, note: null },
		{ p: null, q: null, note: null },
		{ p: null, q: null, note: null },
	],
	requiredSubscriptionLevel: "free",
};

/*
{
	"results": {
		"tpc": "211.35",
		"ppc": "45.54",
		"mwa": "19.91887",
		"g": "0.69",
		"p": [
			"0.0",
			"19.9",
			"38.7",
			"57.7",
			"76.5",
			"95.5",
			"114.3",
			"133.2",
			"152.1",
			"171.0",
			"189.9",
			"208.8",
			"227.7",
			"246.6",
			"265.4",
			"284.4",
			"303.2",
			"322.2",
			"341.0",
			"360.0"
		],
		"q": [
			"1464.6",
			"1459.5",
			"1445.4",
			"1422.0",
			"1389.8",
			"1348.6",
			"1299.1",
			"1241.6",
			"1176.3",
			"1104.2",
			"1025.1",
			"940.1",
			"848.5",
			"751.3",
			"647.7",
			"536.8",
			"418.7",
			"291.0",
			"153.0",
			"0.0"
		]
	},
	"plots": [],
	"warnings": [],
	"errors": []
}
*/

interface IIPRResult {
	tpc: number,
	ppc: number,
	mwa: number,
	g: number,
	p: number[],
	q: number[]
}

interface IIPRRequestResult {
	results: IIPRResult,
	plots: [],
	warnings: [],
	errors: []
}

const converter = new UnitConverter();

const iprCalculatorSlice = createSlice({
	name: "iprCalculator",
	initialState,
	selectors: {
		getDataForSystemPlot: (state, wellId: "well1" | "well2"): { inputs: IDisplayField[], errors: string[] } => {
			const displayedFields: IDisplayField[] = [];
			const well = wellId == "well1" ? state.well1 : state.well2;
			const iprInputs = well.calculationType == "horizontal" ? well.horizontalInputs :
				well.calculationType == "vertical" ? well.verticalInputs :
					well.calculationType == "jones" ? well.jonesInputs : [];

			const requiredInputs = well.calculationType == "vertical" ? ['s', 'r_w', 'h', 'd', 'k_v', 'r_e', 'k_g', 'k', 'k_rg'] :
				well.calculationType == "horizontal" ? ['s', 'r_w', 'delta_l', 'h', 'k_h', 'l', 'd', 'delta_w', 'k_g', 'k', 'k_rg'] :
					well.calculationType == "jones" ? ['a', 'b', 'k_g', 'k', 'k_rg'] : [];

			requiredInputs.map(inputName => {
				const i = iprInputs.find(input => input.queryName === inputName);
				displayedFields.push(
					{
						displayValue: i?.currentValue,
						translationKey: i?.queryName ? `ipr:form_fields.${i?.queryName}` : inputName,
						baseValue: i?.baseValue ?? "",
						currentValue: i?.currentValue ?? "",
						type: "string",
						id: i?.id ?? "",
						unitCategoryId: i?.unitCategoryId ?? null,
						baseUnitId: i?.baseUnitId ?? null,
						currentUnitId: i?.currentUnitId ?? null,
						label: i?.label ?? "",
						queryName: i?.queryName ?? "",
						userValue: i?.userValue ?? null,
						userUnitId: i?.userUnitId ?? null,
						error: i?.currentValue != null ? i.error : "empty"
					}
				);
			});

			return { inputs: displayedFields, errors: [] };
		},
	},
	reducers: {
		setWellInputsData: (state, action: PayloadAction<{ wellId: "well1" | "well2", fields: IField[] }>) => {
			if (action.payload.wellId == "well1") {
				if (state.well1.calculationType == "horizontal")
					state.well1.horizontalInputs = action.payload.fields;
				else if (state.well1.calculationType == "vertical")
					state.well1.verticalInputs = action.payload.fields;
				else if (state.well1.calculationType == "jones")
					state.well1.jonesInputs = action.payload.fields;

				state.well1.results = null;
				state.well1.chartData = {};

				return;
			}
			if (action.payload.wellId == "well2") {
				if (state.well2.calculationType == "horizontal")
					state.well2.horizontalInputs = action.payload.fields;
				else if (state.well2.calculationType == "vertical")
					state.well2.verticalInputs = action.payload.fields;
				else if (state.well2.calculationType == "jones")
					state.well2.jonesInputs = action.payload.fields;

				state.well2.results = null;
				state.well2.chartData = {};
				return;
			}

		},
		setFieldValue: (state, action: PayloadAction<{ wellId: "well1" | "well2", inputName: string, value: number | null }>) => {
			const well = action.payload.wellId == "well1" ? state.well1 : state.well2;
			const inputs = well.calculationType == "horizontal" ? well.horizontalInputs : well.calculationType == "vertical" ? well.verticalInputs : well.jonesInputs;
			inputs.forEach(i => {
				if (i.queryName === action.payload.inputName) {
					i.currentValue = action.payload.value;
					i.baseValue = (i.unitCategoryId && action.payload.value != null) ? converter.convert(action.payload.value, i.currentUnitId, i.baseUnitId) : action.payload.value;
					i.userValue = action.payload.value;
					i.userUnitId = i.currentUnitId;
				}
			});

			well.results = null;
			well.chartData = {};
		},
		updateFieldByUnit: (state, action: PayloadAction<{ wellId: "well1" | "well2", inputId: string, selectedUnitId: unitId | null }>) => {
			const well = action.payload.wellId == "well1" ? state.well1 : state.well2;
			const inputs = well.calculationType == "horizontal" ? well.horizontalInputs : well.calculationType == "vertical" ? well.verticalInputs : well.jonesInputs;
			inputs.forEach(i => {
				if (i.id === action.payload.inputId) {
					i.currentValue = i.currentValue != null ? converter.convert(i.currentValue, i.currentUnitId, action.payload.selectedUnitId) : null;
					i.currentUnitId = action.payload.selectedUnitId;
					i.baseValue = i.userValue && i.userUnitId
						? converter.convert(i.userValue, i.userUnitId, i.baseUnitId)
						: converter.convert(i.currentValue ?? 0, i.currentUnitId, i.baseUnitId);
					return;
				}
			})
		},
		setWell1Type: (state, action: PayloadAction<IPRCalculationType>) => {
			state.well1.calculationType = action.payload;
		},
		setWell2Type: (state, action: PayloadAction<IPRCalculationType>) => {
			state.well2.calculationType = action.payload;
		},
		setNoteP: (state, action: PayloadAction<{ index: number, value: number | null }>) => {
			state.notes[action.payload.index].p = action.payload.value;
		},
		setNoteQ: (state, action: PayloadAction<{ index: number, value: number | null }>) => {
			state.notes[action.payload.index].q = action.payload.value;
		},
		setNote: (state, action: PayloadAction<{ index: number, value: string | null }>) => {
			state.notes[action.payload.index].note = action.payload.value;
		},
		addNote: (state) => {
			state.notes.push({ p: null, q: null, note: null });
		},
		removeNote: (state, action: PayloadAction<number>) => {
			state.notes.splice(action.payload, 1);
		},
		validateInputs: (state) => {
			[
				...state.well1.verticalInputs,
				...state.well1.horizontalInputs,
				...state.well1.jonesInputs,
				...state.well2.verticalInputs,
				...state.well2.horizontalInputs,
				...state.well2.jonesInputs
			].forEach(input => {
				if (input.min != null && input.currentValue != null && input.currentValue < input.min) {
					input.error = "validation.min_value_error";
					input.errorParams = { min: input.min };
				} else if (input.max != null && input.currentValue != null && input.currentValue > input.max) {
					input.error = "validation.max_value_error";
					input.errorParams = { max: input.max };
				} else {
					input.error = null;
					input.errorParams = null;
				}
			});
		}
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(apiSlice.endpoints.calculator.matchFulfilled, (state, action) => {
				const params = action.meta.arg.originalArgs as Record<string, string>;
				if (!params?.calculator_type) {
					console.warn("No calculator_type in calculator response");
					return;
				}
				if (params.calculator_type != "ipr") {
					return;
				}
				const response = action.payload as IIPRRequestResult;
				if (params["well"] == "1" && response?.results) {
					state.well1.results = response.results;
				}

				if (params["well"] == "2" && response?.results) {
					state.well2.results = response.results;
				}
			})
	}
})

export default iprCalculatorSlice

export const {
	setFieldValue,
	updateFieldByUnit,
	setWellInputsData,
	setWell1Type,
	setWell2Type,
	setNoteP,
	setNoteQ,
	setNote,
	addNote,
	removeNote,
	validateInputs
} = iprCalculatorSlice.actions

export const {
	getDataForSystemPlot
} = iprCalculatorSlice.selectors;